import { jwtDecode } from 'jwt-decode';

/**
 * Decodes the payload of a JWT and returns it as a typed object.
 *
 * Returns an empty object if the token is malformed or cannot be decoded,
 * rather than throwing, so callers can handle missing claims gracefully.
 */
export const decodeJwtPayload = <T extends Record<string, unknown>>(
  token: string,
): Partial<T> => {
  try {
    return jwtDecode<T>(token);
  } catch {
    return {};
  }
};
